<form
  [formGroup]="formGroup()"
  (ngSubmit)="onSubmit()"
  [ngClass]="classStyle()"
>
  <ng-content />
</form>
